import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getters } from "@/store/data/global";
import {
  getLocaleFromPath,
  LOCALE,
  EN_PREFIX,
  stripEnPrefix,
} from "@/utils/locale";
import { useFooterNav } from "./useFooterNav";
import FooterZh from "./FooterZh";
import FooterEn from "./FooterEn";
import "./index.less";

const BottomPage = () => {
  const location = useLocation();
  const pathname = location?.pathname || "/";
  const locale = getLocaleFromPath(pathname);
  const isEnglish = locale === LOCALE.EN;
  const homePath = isEnglish ? EN_PREFIX : "/";
  const { contactInfo } = useSelector(getters);
  const { navList } = useFooterNav(isEnglish, locale);

  if (stripEnPrefix(pathname) === "/Nous") {
    return null;
  }

  const footerProps = { navList, contactInfo, homePath };

  return isEnglish ? (
    <FooterEn contactInfo={contactInfo} homePath={homePath} />
  ) : (
    <FooterZh {...footerProps} />
  );
};

export default BottomPage;
